import React from 'react';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import Home from './site/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PrivacyPolicyPartnership from './pages/PrivacyPolicyPartnership';
import FCOI from './pages/FCOI';
import useSiteFont from './site/useSiteFont';

const App = () => {
  useSiteFont();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/fcoi" element={<FCOI />} />
        <Route
          path="/privacy/:appName"
          element={<PrivacyPolicyPartnership />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
